import { useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";
const encryptData = async (input) => {
  const { data } = await http_payroll.post(Api_EndPoints.QREncryption, input);
  return data;
};

export const useEncryptionMutation = () => {
  return useMutation({
    mutationFn: encryptData,
  });
};
